var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5h12M5 2h6M3.5 5v7.5a1 1 0 001 1h7a1 1 0 001-1V5M8 7.5v3",
    stroke: "#676A70"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgNC41SDE0IiBzdHJva2U9IiM2NzZBNzAiLz4KPHBhdGggZD0iTTUgMkgxMSIgc3Ryb2tlPSIjNjc2QTcwIi8+CjxwYXRoIGQ9Ik0zLjUgNVYxMi41QzMuNSAxMy4wNTIzIDMuOTQ3NzIgMTMuNSA0LjUgMTMuNUgxMS41QzEyLjA1MjMgMTMuNSAxMi41IDEzLjA1MjMgMTIuNSAxMi41VjUiIHN0cm9rZT0iIzY3NkE3MCIvPgo8cGF0aCBkPSJNOCA3LjVWMTAuNSIgc3Ryb2tlPSIjNjc2QTcwIi8+Cjwvc3ZnPgo=";
export { SvgBottomDelete as ReactComponent };